/**
 * Field wrapper for Dragon theme
 */
export enum ISPFieldWrapper {
  Page = 'page',
  InputBase = 'input-base',
  FieldBase = 'field-base',
  FieldChip = 'field-chip',
  ValidationError = 'validation-error',
}
